export default "__VITE_ASSET__C2mfp95N__"